// extracted by mini-css-extract-plugin
module.exports = {"ArticleTable":"ArticleTable_ArticleTable__Milqi","ArticleTable___hasOverflowContent":"ArticleTable_ArticleTable___hasOverflowContent__GDh1h"};